import { GlobalSearch } from './GlobalSearch';
import {
  LanguageMenu,
  LocationSwitcher,
  NewOperationMenu,
  NotificationsButton,
  UserMenu,
} from './TopBarMenus';

/** Top bar of the design ("Component top bar"), desktop and tablet landscape. */
export function TopBar() {
  return (
    <div className="sticky top-0 z-30 hidden h-[84px] items-center gap-3 border-b border-line bg-surface/95 px-6 backdrop-blur lg:flex xl:px-10 print:!hidden">
      <GlobalSearch />
      <div className="ml-auto flex shrink-0 items-center gap-2.5">
        <LocationSwitcher />
        <NewOperationMenu />
        <NotificationsButton />
        <LanguageMenu />
        <UserMenu />
      </div>
    </div>
  );
}
